import { useReducedMotion } from 'motion/react';

import { RESPECT_REDUCED_MOTION } from '../../theme/motion';

/**
 * Single-source-of-truth reduced-motion hook (spec §9.1).
 *
 * Motion primitives must NOT read Motion's `useReducedMotion()` directly;
 * they branch on this hook so the `RESPECT_REDUCED_MOTION` flag governs both
 * the global `<MotionConfig>` and any per-component reduced-motion handling
 * consistently.
 *
 * - When `RESPECT_REDUCED_MOTION` is `false` (the default), this always
 *   returns `false` — animations ignore the OS preference and always play.
 * - When the flag is flipped to `true`, this follows the OS
 *   `prefers-reduced-motion` setting via Motion's hook.
 */
export function usePrefersReduced(): boolean {
  const osReduced = useReducedMotion();
  return RESPECT_REDUCED_MOTION ? !!osReduced : false;
}
